import { Checkbox } from "components/common/Checkbox/Checkbox";
import { Translate } from "components/common/Translate/Translate";
import type { TextBox } from "store/features/memeGenerator/types";
import { Opacity } from "./Opacity/Opacity";
import { useMoreOptionsContent } from "./useMoreOptionsContent";

export interface MoreOptionsContentProps {
    textBox: TextBox;
}

export const MoreOptionsContent = ({ textBox }: MoreOptionsContentProps) => {
    const { handleAllCapsClick, handleApplyToAllFonts } = useMoreOptionsContent(textBox);
    return (
        <div className="absolute top-full translate-y-2 bg-white dark:bg-darkSurface-200 py-6 rounded-xl shadow-[0px_4px_50px_rgba(0,0,0,0.08)] flex flex-col gap-4 dark:border dark:border-darkSurface-100 text-black dark:text-white">
            <div className="px-6">
                <Checkbox label={`ALL CAPS`} defaultIsChecked={textBox.forceCaps} handleChange={handleAllCapsClick} />
            </div>
            <Divider />
            <Opacity textBox={textBox} />
            <Divider />
            <div className="px-6">
                <button
                    className="py-2 border border-irGray-200 dark:border-darkSurface-400 rounded-[10px] text-center hover:bg-irGray-100 w-full dark:bg-darkSurface-300 dark:hover:bg-darkSurface-400"
                    onClick={handleApplyToAllFonts}
                >
                    <Translate keyName="apply-to-all-fonts" />
                </button>
            </div>
        </div>
    );
};

const Divider = () => <div className="w-full h-[1px] bg-irGray-200 dark:bg-darkSurface-400"></div>;
